import axios from "axios";
import Paths from "../../constant/constant";

export async function deleteDevice(id) {
  return await axios
    .post(Paths.API_URL + `/api/v1/deldevice/${id}`)
    .then((res) => {
      return res.data;
    })
    .catch(function (e) {});
}
